import { API } from "@/lib/api";

// Reuse the same stable client id our presence heartbeat uses. Falls back
// to null in private mode / storage-disabled browsers, where the backend
// then keys the rate-limit by IP as before.
const VISITOR_KEY = "sl_visitor_id";
function _getVisitorId() {
  try {
    return localStorage.getItem(VISITOR_KEY) || null;
  } catch {
    return null;
  }
}

/** Fire-and-forget click ping. Uses sendBeacon so the request survives the
 * immediate navigation to Discord and never blocks the join. */
export function trackJoinClick(serverId) {
  _fireBeacon(serverId, "track-click");
}

/** Fire-and-forget view ping on the server-detail page. Beacon so page nav
 * (e.g. immediately clicking Join) never truncates the request. */
export function trackServerView(serverId) {
  _fireBeacon(serverId, "track-view");
}

function _fireBeacon(serverId, path) {
  if (!serverId) return;
  const vid = _getVisitorId();
  const url = `${API}/servers/${serverId}/${path}${vid ? `?vid=${encodeURIComponent(vid)}` : ""}`;
  try {
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      // Empty Blob keeps the Content-Type simple and avoids CORS preflight.
      const blob = new Blob([], { type: "text/plain" });
      if (navigator.sendBeacon(url, blob)) return;
    }
  } catch {
    /* ignore — fallback below */
  }
  try {
    fetch(url, { method: "POST", keepalive: true, credentials: "omit" }).catch(() => {});
  } catch {
    /* swallow */
  }
}
